import React, { useContext } from 'react';
import { Form, Input } from 'antd';
// import _ from 'lodash-es';
import { ThemeContext } from 'styled-components';
// 引入ButtonStyled 组件
import { SingInputStyled } from './SingInputMLStyled';
import { BrandContext } from '@/contexts/ContextProviders';
import classnames from 'classnames';

// import commStyles from '@/comm.less?modules';
const { TextArea } = Input;
/**
 * 头部OK按钮
 * @param {*} param
 */
const SingInputML = ({
  labelVal,
  placeVal,
  icon,
  height,
  labelwidth,
  inputWidth,
  maxWidth,
  name,
  require = [{}],
  password = false,
  disabled,
  value,
  allowClear = false,
  isTextArea = false,
  className,
  onBlur,
  refs,
}) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  return (
    <SingInputStyled
      theme={themeContext}
      brand={brandContext}
      inputWidth={inputWidth}
      maxWidth={maxWidth}
      height={height}
      labelwidth={labelwidth}
    >
      <>
        <Form.Item
          colon={false}
          name={name}
          rules={require}
          label={
            <>
              {icon ? icon : ''}
              {labelVal}
            </>
          }
          className={
            className instanceof Array ? classnames(...className) : className
          }
        >
          {password ? (
            <Input.Password placeholder={placeVal} />
          ) : isTextArea ? (
            <TextArea
              rows={2}
              placeholder={placeVal}
              disabled={disabled}
              value={value}
              allowClear={allowClear}
            />
          ) : (
            <Input
              placeholder={placeVal}
              disabled={disabled}
              value={value}
              defaultValue={value}
              allowClear={allowClear}
              onBlur={onBlur}
              ref={refs}
            />
          )}
        </Form.Item>
      </>
    </SingInputStyled>
  );
};

export default SingInputML;
